import { Routes, withComponentInputBinding } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/app/dashboard/dashboard.component';
import { MainComponent } from './components/app/main/main.component';
import { AuthGuard } from './components/app/guards/auth.guard';
import { AuthComponent } from './components/app/shared/auth/auth.component';
import { UserProfileComponent } from './components/app/main/user-profile/user-profile.component';
import { UserListComponent } from './components/app/admin/user/user-list/user-list.component';
import { AdminGuard } from './components/app/guards/admin.guard';
import { ChargeScanComponent } from './components/app/main/charge-scan/charge-scan.component';

export const routes: Routes = [
    { path: 'auth', component: AuthComponent },
    { path: 'login', component: LoginComponent },
    { path: '', redirectTo: "app/dashboard", pathMatch: 'full' },

    {
        path: 'app', component: MainComponent,
        children: [
            { path: '', redirectTo: "dashboard", pathMatch: 'full' },
            { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
            { path: 'admin/user-list', component: UserListComponent, canActivate: [AuthGuard, AdminGuard] },

            { path: 'charge-scan', component: ChargeScanComponent, canActivate: [AuthGuard] },

            { path: 'user-profile', component: UserProfileComponent, canActivate: [AuthGuard] },

        ], canActivate: [AuthGuard]
    },

    { path: '', component: MainComponent, canActivate: [AuthGuard] },
    { path: '**', redirectTo: '/app/dashboard' } // Default Route

];
